import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "select_landing_page_link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_ap_button = _resolveComponent("ap-button")!
  const _component_ApModalBase = _resolveComponent("ApModalBase")!

  return (_openBlock(), _createBlock(_component_ApModalBase, {
    name: _ctx.name,
    titleIcon: 'ap-icon-logo',
    title: _ctx.$t('page.sms-template.content.title.landing-page-link'),
    showClose: true,
    width: 675,
    height: null,
    onOpen: _ctx.beforeOpen,
    "cancel-text": _ctx.$t('modal.close')
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_ap_button, {
        "btn-class": "btn-primary",
        onClick: _ctx.modalSearch
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('modal.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Carousel, { onOnSelected: _ctx.pageSelected }, null, 8, ["onOnSelected"])
      ])
    ]),
    _: 1
  }, 8, ["name", "title", "onOpen", "cancel-text"]))
}